export type QuickBooksTxnKind = "bill" | "invoice";

export function quickbooksTxnUrl(kind: QuickBooksTxnKind, txnId: string): string | null {
  const id = txnId.trim();
  if (id === "") {
    return null;
  }
  const page = kind === "bill" ? "bill" : "invoice";
  return `https://qbo.intuit.com/app/${page}?txnId=${encodeURIComponent(id)}`;
}
